/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {hasPublishedSchedule} from '../api'

export const useMutationHasPublishedSchedule = createReactQueryMutationHook('hasPublishedSchedule', hasPublishedSchedule)
